import { create } from 'zustand';

export interface PopupType {
   dismissible?: boolean
   type: string
   body?: string
   children?: React.ReactElement
   closeButton?: React.ReactElement
   closeButtonColor?: string
   uuid?: number
   close?: boolean
}

interface Popups {
   new_uuid: number
   popups: PopupType[]
}

interface PopupAction {
   addPopup: (popup: PopupType) => number
   removePopup: (id: number) => void
}

export const usePopupStore = create<Popups & PopupAction>()(
   (set) => ({
      new_uuid: 1,
      popups: [],
      addPopup: (popup) => {
         let uuid = 0;
         set((state) => {
            uuid = state.new_uuid + 1;
            return {new_uuid:uuid, popups:[...state.popups, {...popup, uuid: uuid}]};
         });
         return uuid;
      },
      removePopup: (id: number) => set((state) => ({popups:[...state.popups].filter((g)=>id!==g.uuid)}))
   })
);
